<template>
    <b-modal
      v-model="isModalOpen"
      size="lg"
      @hidden="emitAction('close')"
      hide-header
      hide-footer
    >
       <div class="custom-modal-header d-flex justify-content-between align-items-center" style="padding: 20px">
        <h5 class="modal-title font-16">{{ modalData.companyName }}</h5>
        <button 
          type="button" 
          class="close" 
          @click="emitAction('close')"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="jd-details" style="">
        <div class="jd-section jd-title-section">
          <h3>{{ modalData.jd.job_title }}</h3>
        </div>
        
        <div v-if="jobUpdateDate" class="jd-section jd-date-section">
          <div class="job-update-date">
            <span class="date-label">求人更新日：</span>
            <span class="date-value">{{ jobUpdateDate }}</span>
          </div>
        </div>
  
        <div class="jd-section jd-info-section">
          <div v-html="modalData.jd.job_description"></div>
        </div>
      </div>
  
      <div class="custom-modal-footer" v-if="!modalData.isReplied">
        <div class="btn-container d-flex flex-column align-items-center" style="gap: 10px;">
          <b-button
              v-if="modalData.isQuestion"
              class="custom-btn question-btn"
              @click="emitAction('question')"
          >質問する</b-button>

          <b-button
              class="custom-btn apply-btn"
              @click="emitAction('submit')"
          >
            <span class="btn-main-text" v-html="applyButtonMainText"></span>
            <span class="btn-sub-text" v-if="modalData.contactType !== 'カジュアル面談'">回答画面に進みます</span>
          </b-button>

          <b-button
              class="custom-btn refrain-btn"
              @click="emitAction('refrain')"
          >
            <span class="btn-main-text">今回は控える</span>
            <span class="btn-sub-text" v-if="modalData.showDifferentPosition">別求人への希望も可能です</span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </template>
  
  <script>
  import moment from 'moment';
  export default {
    name: 'IndividualJDModal',
    
    props: {
      modalData: {
          type: Object,
          required: true
      },
      // jd: {
      //   type: Object,
      //   required: true,
      // },
      // isOpen: {
      //   type: Boolean,
      //   default: false
      // },
      // buttonText: {
      //   type: String,
      //   required: true
      // },
      // isReplied: {
      //   type: Boolean,
      //   default: false
      // },
      // isQuestion: {
      //   type: Boolean,
      //   default: false
      // }
    },
  
    computed: {
      applyButtonMainText() {
          const type = this.modalData.contactType;
          if (type === '面接案内') return '面接に参加する';
          if (type === 'カジュアル面談') return 'カジュアル面談に<br/>参加する';
          return '応募する';
      },
      isModalOpen: {
          get() {
              return this.modalData.isOpen
          },
          set(value) {
              if (!value) {
                  this.emitAction('close')
              }
          }
      },
      jobUpdateDate() {
          const jd = this.modalData.jd;
          if (!jd) return null;
          
          // Check if updated_date exists, otherwise use created_date
          const dateToShow = jd.updated_date || jd.created_date;
          
          if (!dateToShow) return null;
          
          // Format the date using moment.js in YYYY-MM-DD format
          return moment(dateToShow).format('YYYY/MM/DD');
      }
    },
    methods: {
      hide() {
        if (this.$refs.jdModal) {
          this.$refs.jdModal.hide();
        }
      },
      emitAction(action) {
          this.$emit('modal-action', action);
      },
    }
  }
  </script>
  
  <style scoped>
  ::v-deep .modal {
    padding-left:0px !important;
  }
  ::v-deep .modal-body {
      padding: 0px !important;
  }
  .question-btn {
    background-color: #2F80ED !important;
    border-color: #2F80ED !important;
    color: #fff !important;
  }

  .apply-btn {
    background-color: #006C6B !important;
    border-color: #006C6B !important;
    color: #fff !important;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .refrain-btn {
    background-color: #fff !important;
    border: 1px solid #000 !important;
    color: #000 !important;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .refrain-btn .btn-sub-text {
    color: #FD1010 !important;
  }

  .btn-main-text {
    display: block;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .btn-sub-text {
    display: block;
    font-size: 11px;
    margin-top: 2px;
    font-weight: normal;
  }
  .font-16 {
      font-size: 16px;
  }
  .jd-section {
      text-align: left;
      padding: 30px 50px;
  }
  
  .jd-title-section {
      background: #ededed;
      height: 76px;
      padding: 30px 20px;
  }
  
  .jd-date-section {
      padding: 15px 20px;
  }
  
  .jd-info-section {
      max-height: 400px;
      overflow-y: auto;
      padding: 20px;
  }
  
  .jd-info-section p {
      font-size: 16px;
  }
  
  .jd-section h3 {
    margin: 0;
    color: #2c3e50;
    font-size: 16px;
  }
  
  .job-update-date {
    font-size: 14px;
  }
  
  .company {
    color: #666;
    font-size: 1.1rem;
    margin: 0.5rem 0;
  }
  
  .custom-modal-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 2rem;
    background-color: #F2F5F7;
    border-top: 1px solid #dee2e6;
  }
  .submit-btn {
    background-color: #4F46E5 !important;
    border-color: #4F46E5 !important;
  }
  .custom-btn {
    border-radius: 4px !important;
    width: 325px;
    height: 60px;
    padding: 20px 25px;
    white-space: nowrap;
  }
  
  .custom-btn:disabled {
      opacity: 1;
  }

  .different-position-btn {
    min-width: 200px;
    color: #fff;
    background-color: #15b9a6 !important;
    border-color: #15b9a6 !important;
  }

  @media (max-width: 768px) {
    .custom-modal-footer{
      padding: 0.75rem;
    }
    .custom-btn {
      width: 325px;
      height: 60px;
      padding: 20px 25px;
      border-radius: 4px !important;
      font-size: 11px;
      font-weight: bold;
      white-space: nowrap;
    }
    .jd-title-section {
      padding: 10px 20px;
    }
  }
  
  </style>
  